// Declaring names of the AJAX widgets 
const diWidgets = [
    'back-image-request',
    'front-image-request',
    'back-endsheet-image-request',
    'front-endsheet-image-request',
    'spine-image-request',
    'front-cover-image-request',
    'back-cover-image-request',
    'art-print-image-request',
    'framed-image-request',
    'in-space-image-request'
];

const canvasName = 'imprint';

window.ccDownloadHelper = (main, self, type) => {
  let response
  try {
   response = main.scopeInternal.$[diWidgets[0]].response
  } catch {
    try {
     	response = main.scopeInternal.$[diWidgets[3]].response
    } catch {
    	response = main.scopeInternal.$[diWidgets[5]].response
    }
  }

    if (main.scopeInternal.$[canvasName].hiResUrls === undefined || response === undefined) {
        self.showToast('The product is being rendered, please wait and try again.');
        return;
    }

    switch (type) {
        case 'mockup':
            self.showToast('The mockups are being dowloaded, please wait.');
			ccFileZipper(main, 'mockup');
            break;

        case 'hires':
            self.showToast('The print file is being dowloaded, please wait.');
            ccFileZipper(main, 'hires');
            break;
    }
}

const ccFileZipper = (main, type) => {
    const zip = new JSZip();
    const urls = [];
    const promises = [];

    if (type === 'mockup') {
      diWidgets.forEach((widget) => {
        try {
        	urls.push(main.scopeInternal.$[widget].response);
        }
        catch {
        	console.warn("The widget missed")
        }
      });
    } else if (type === 'hires') {
      main.scopeInternal.$[canvasName].hiResUrls.forEach((url) => {
        urls.push(url)
      });
    } else {
      console.error('Incorrect type provided');
      return;
    }

    urls.forEach(async function (url, i) {
      let promise = new Promise ( async (resolve, reject) => {
      let response = await fetch(url);

      response.blob().then((blob) => {
        if (type === 'mockup') {
          zip.file(`mockup-${i + 1}.jpg`, blob);
        }
        if (type === 'hires') {
          zip.file(`design-${i + 1}.pdf`, blob);
        }
        resolve();
      }).catch((e) => {
        console(`Fetching of designs failed with error: ${e}`);
        reject();
      });
    })
    promises.push(promise);
  });

  Promise.all(promises)
  .then(async () => {
      let content = await zip.generateAsync({ type: "blob" })
	  var a = document.createElement("a");
	  a.download = `${type}.zip`;
      a.href = URL.createObjectURL(content);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
  });
}